<template>
  <SfSidebar
    :visible="isVisible"
    class="sf-sidebar--right sf-sidebar--icon sf-sidebar__shipping-costs"
    @close="closeModal"
  >
    <div class="shipping-costs-content">
      <SfHeading
        class="sf-heading--left"
        :title="page.title"
        :level="2"
      />
      <div class="sf-sidebar-shipping-costs-content" v-html="page.content" />
      <!-- div class="sf-sidebar-shipping-costs-note">
        <div class="sf-sidebar-shipping-costs-note-head">
          Aktuelle Hinweise zu COVID-19:
        </div>
        <div class="sf-sidebar-shipping-costs-note-content">
          <p>Derzeit erreichen uns sehr viele Bestellungen. Wegen der aktuellen COVID-19-Situation und den temporären Engpässen im Lager- und Transportwesen kann es zu Verzögerungen in der Belieferung kommen. Der tatsächliche Liefertermin kann möglicherweise von einem bereits bestätigtem Liefertermin abweichen.</p>
          <p>Wir sind sehr bemüht, diese Probleme auf ein Minimum zu reduzieren, soweit wir die Möglichkeit dazu haben. Wir entschuldigen uns deswegen bereits jetzt schon und möchten Sie bitten, diesen Aspekt bei einer möglichen Kundenbewertung zu berücksichtigen.</p>
          <p>Vielen Dank für Ihr Verständnis!</p>
        </div>
      </div>

      <div class="sf-sidebar-shipping-costs-content">
        <div class="sf-sidebar-shipping-costs-content-head">
          Lieferungen innerhalb Deutschlands:
        </div>

        <div class="shipping-costs-table">
          <table cellspacing="0">
            <thead>
              <tr>
                <th></th>
                <th>Warenwert</th>
                <th>Versandart</th>
                <th>Versandkosten</th>
              </tr>
            </thead>
            <tbody>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Muster</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Post</td>
                <td class="shipping-costs-table-cell-price">€ 4,90</td>
              </tr>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Laminat, Design- und Vinylböden bis 30 kg</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Sperrgut</td>
                <td class="shipping-costs-table-cell-price">€ 22,95</td>
              </tr>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Parkett bis 30 kg</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Spedition</td>
                <td class="shipping-costs-table-cell-price">€ 69,95</td>
              </tr>
              <tr class="shipping-costs-table-row shipping-costs-table-before-child">
                <td class="shipping-costs-table-cell-name">Laminat, Design- und Vinylböden und Parkett über 30 kg</td>
                <td class="shipping-costs-table-cell-cart-price">bis 499,99 €</td>
                <td class="shipping-costs-table-cell-shipping-methode">Spedition</td>
                <td class="shipping-costs-table-cell-price">€ 69,95</td>
              </tr>
              <tr class="shipping-costs-table-row shipping-costs-table-child">
                <td class="shipping-costs-table-cell-name"></td>
                <td class="shipping-costs-table-cell-cart-price">ab 500,00 €</td>
                <td class="shipping-costs-table-cell-shipping-methode">Spedition</td>
                <td class="shipping-costs-table-cell-price">(frachtfrei) 0,00 €</td>
              </tr>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Bodenbeläge aus Kategorie "% Sale % > Sonderposten"</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Spedition</td>
                <td class="shipping-costs-table-cell-price">€ 69,95</td>
              </tr>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Türen & Zargen</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Spedition</td>
                <td class="shipping-costs-table-cell-price">€ 99,95</td>
              </tr>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Zubehör / Kleinteile je 30 kg</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Paket</td>
                <td class="shipping-costs-table-cell-price">€ 6,50</td>
              </tr>
              <tr class="shipping-costs-table-row">
                <td class="shipping-costs-table-cell-name">Sockelleisten / Aluschienen je 30 kg</td>
                <td class="shipping-costs-table-cell-cart-price"></td>
                <td class="shipping-costs-table-cell-shipping-methode">Sperrgut</td>
                <td class="shipping-costs-table-cell-price">€ 22,95</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div -->
    </div>
  </SfSidebar>
</template>

<script>
import i18n from '@vue-storefront/i18n';
import { SfSidebar, SfHeading, SfButton } from '@storefront-ui/vue';
import { Logger } from '@vue-storefront/core/lib/logger'

export default {
  name: 'SidebarShippingCosts',
  components: { SfSidebar, SfHeading, SfButton },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      page: null
    };
  },
  created () {
    this.$store.dispatch('cmsPage/single', {
      value: 'versandkosten',
      setCurrent: true
    }).then(page => {
      this.page = page
    }).catch(err => {
      Logger.error(err)()
    })
  },
  methods: {
    closeModal () {
      this.$emit('close', this.modalData.name)
    }
  }
};
</script>
